export default "__VITE_ASSET__537e6932__"